import { createSlice } from '@reduxjs/toolkit'
import status from '../../stub/status.json'
import warrantyStatus from '../../stub/warrantyStatus.json'
import role from '../../stub/role.json'
import subRole from '../../stub/subRole.json'
import accountStatus from '../../stub/accountStatus.json'

const initialState = {
  status: status,
  warrantyStatus: warrantyStatus,
  accountStatusList: accountStatus,
  roleList: role,
  subRoleList: subRole,
  categoryList: [],
  communeList: [],
  customerList: [],
  distributorList: [],
}

export const optionListSlice = createSlice({
  name: 'optionListSlice',
  initialState,
  reducers: {
    updateStatus: (state, action) => {
      state.status = action.payload
    },
    updateRole: (state, action) => {
      state.roleList = action.payload
    },
    updateAccountStatus: (state, action) => {
      state.accountStatusList = action.payload
    },
    updateCategory: (state, action) => {
      state.categoryList = action.payload
    },
    updateProvince: (state, action) => {
      state.provinceList = action.payload
    },
    updateCommune: (state, action) => {
      state.communeList = action.payload
    },
    updateCustomer: (state, action) => {
      state.customerList = action.payload
    },
    updateDistributor: (state, action) => {
      state.distributorList = action.payload
    },
    updateWarranty: (state, action) => {
      state.warrantyStatus = action.payload
    },
  },
})

export const {
  updateStatus,
  updateRole,
  updateAccountStatus,
  updateCategory,
  updateProvince,
  updateCommune,
  updateCustomer,
  updateDistributor,
  updateWarranty,
} = optionListSlice.actions

export default optionListSlice.reducer
